import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class CommercialCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Commercial Cleaning Gold Coast | Office & Business Cleaning"
          description="Commercial cleaning Gold Coast for offices, restaurants, retail stores and warehouses. Professional and reliable service."
          keywords="commercial cleaning gold coast, office cleaning gold coast, restaurant cleaning gold coast, warehouse cleaning gold coast, retail cleaning gold coast, professional commercial cleaners gold coast, medical cleaning gold coast, industrial cleaning gold coast, strata cleaning gold coast, body corporate cleaning gold coast, corporate cleaning gold coast, business cleaning gold coast, office sanitisation gold coast, hospitality cleaning gold coast, commercial kitchen cleaning gold coast, builders cleaning gold coast, post construction cleaning gold coast, after renovation cleaning gold coast, special event cleaning gold coast, reliable commercial cleaners gold coast, affordable commercial cleaning gold coast, high rise cleaning gold coast, commercial carpet cleaning gold coast, commercial window cleaning gold coast, deep commercial cleaning gold coast, contract cleaning gold coast, daily office cleaning gold coast, weekly commercial cleaning gold coast, office maintenance cleaning gold coast, professional business cleaners gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Commercial Cleaning Services Gold Coast
                </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            Commercial Cleaning Services Gold Coast
                          </h4>
                          <p>
                            A clean workplace is essential for productivity,
                            health and maintaining a professional image.
                            Kangaroo Shine Property Services provides
                            professional commercial cleaning Gold Coast
                            businesses rely on for consistent and high-quality
                            results.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Office Cleaning Gold Coast
                          </h4>
                          <p>
                            A clean office promotes productivity. Our service
                            includes: Vacuuming and moping, Dusting
                            desks/furniture, Workstation sanitisation, Cleaning
                            restrooms, and Waste management.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Retail & Restaurant Cleaning
                          </h4>
                          <p>
                            First impressions matter in retail and hospitality.
                            We ensure your dining areas, display areas, and
                            customer restrooms are spotless. For restaurants, we
                            provide specialised kitchen degreasing and
                            sanitisation to ensure compliance with hygiene
                            regulations.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Warehouse & Industrial Cleaning
                          </h4>
                          <p>
                            Industrial spaces accumulate dust quickly. We
                            provide thorough floor cleaning, high-surface
                            dusting, and general debris removal to maintain a
                            safe and productive environment.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default CommercialCleaningGoldCoast;
